/* TTG Anlass-Seite Vatertag „Papas Werkzeugwand“ (21.10.2026, Briefing anlass-main-2026-10-21).
   1. Etiketten: Sprungziele, die auf der Seite fehlen, ausblenden; Sprung mit Abstand (eingeblendeter Theme-Header
      beim Hochspringen).
   2. Lochwand: Lochraster jeder Section an der Seitenoberkante ausrichten (--ttg-vt-raster-y), damit es über die
      Section-Grenzen ohne Versatz durchläuft.
   Wird von mehreren Sections eingebunden (defer) und läuft trotzdem nur einmal. */
(() => {
  if (window.__ttgVatertag) return;
  window.__ttgVatertag = true;

  const RASTER = 28;
  const bewegung = () => !window.matchMedia || window.matchMedia('(prefers-reduced-motion: no-preference)').matches;

  const headerHoehe = () => {
    const h = document.querySelector('#header-component');
    if (!h || !h.getAttribute('sticky')) return 0;
    const v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
    return Number.isFinite(v) && v > 0 ? v : h.getBoundingClientRect().height;
  };

  /* ---------- 1 Etiketten ---------- */
  const etikettenPruefen = () => {
    document.querySelectorAll('[data-ttg-vt-etiketten] a[href^="#"]').forEach((a) => {
      const id = decodeURIComponent(a.getAttribute('href').slice(1));
      a.hidden = !id || !document.getElementById(id);
    });
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest('.ttg-vt a[href^="#"]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const id = decodeURIComponent(a.getAttribute('href').slice(1));
    const ziel = id && document.getElementById(id);
    if (!ziel) return;
    e.preventDefault();
    const y = ziel.getBoundingClientRect().top + window.scrollY;
    const hoch = y < window.scrollY;
    window.scrollTo({ top: Math.max(0, Math.round(y - (hoch ? headerHoehe() : 0) - 24)), behavior: bewegung() ? 'smooth' : 'auto' });
    try { history.replaceState(null, '', `#${id}`); } catch (err) { /* ohne History bleibt der Sprung */ }
    if (!ziel.hasAttribute('tabindex')) ziel.setAttribute('tabindex', '-1');
    ziel.focus({ preventScroll: true });
  });

  /* ---------- 2 Lochwand ---------- */
  const rasterAusrichten = () => {
    document.querySelectorAll('[data-ttg-vt-wand]').forEach((el) => {
      const oben = el.getBoundingClientRect().top + window.scrollY;
      const versatz = ((14 - oben) % RASTER + RASTER) % RASTER;
      el.style.setProperty('--ttg-vt-raster-y', `${versatz}px`);
    });
  };

  const start = () => {
    etikettenPruefen();
    rasterAusrichten();
    window.addEventListener('resize', rasterAusrichten);
    window.addEventListener('load', rasterAusrichten);
    if (window.ResizeObserver) new ResizeObserver(rasterAusrichten).observe(document.body);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
